import React from 'react'
import CaseStudyHeader from '../../components/Header/CSHeader/CaseStudyHeader.jsx'

import './Du.scss'
import ducover from './assets/ducover.webp'
import aicover from './assets/aicover.webp'


function Du() {
    return (

        <section>

            <CaseStudyHeader Pagetitle="Digital transformation at du telecom" />

            <img className='cover-img' src={ducover} alt="" />
          



            <div className='cs-content'>


                <div className="top-l"></div>


                <h2> Redesigning customer experiences : digital transformation at du telecom </h2>



            </div>


            <div className='cs-content'>

                <p className="md">
                    du is a leading telecom provider in the UAE, offering a wide range of services. These include prepaid and postpaid plans, high-speed internet for homes and businesses, and Wi-Fi solutions. du also provides TV services, including IPTV channels.
                    <br /> <br />
                    du is currently undergoing a digital transformation to enhance customer experiences across its app and web platforms. This initiative focuses on creating more seamless, intuitive, and efficient digital interactions, aligning with the growing expectations of today’s consumers.
                </p>


            </div>

            <div className='cs-content'>

                <h4>My role in digital transformation; improving digital channel experience app and web </h4>



                <p>As a member of the Experience Design team at du, I contributed to the digital transformation of du’s customer outlets, including the mobile app and website. My work involved translating business requirements into intuitive user experiences and enhancing the UI to improve both usability and aesthetics. This was achieved by analyzing existing flows to identify areas for improvement or, for new features, designing flows based on intuition and conducting A/B testing to determine the most optimal user journey.  <br /> <br />

                    Additionally, I actively participated in workshops and strategic discussions, collaborating closely with design teams, product owners, and developers to ensure design solutions aligned with business goals and customer needs. Through this collaborative approach, I helped ensure the final digital products met users’ and business needs.</p>



            </div>

            <div className='cs-content'>

                <h4>Designing du AI suite - internal tool</h4>

                <p>du AI Suite is a collection of AI-powered tools designed to enhance workflows and boost productivity for in-house developers and designers. I was responsible for designing multiple tools end-to-end. Due to the confidential nature of this project, more cannot be revealed here. feel free to reach out to learn more about my role in this project.</p>
               
            </div>

            <img className='cover-img' src={aicover} alt="" />

            <div className='cs-content'>

                <h4>Non Disclosure</h4>

                <p>Due to the nondisclosure nature of this project, I am unable to share further details or provide a case study. However, I would be happy to discuss my role and contributions at du during an interview.</p>
                
            </div>


            <div className='cs-content'>

            </div>


            {/* 

                <div className='toc-container'>

                    <div className="top-l"></div>
                    <a href="/"><p>As a team member </p></a>
                    <a href="/"><p>Go to Link 1</p></a>
                    <a href="/"><p>Go to Link 1</p></a>
                    <a href="/"><p>Go to Link 1</p></a>
                    <a href="/"><p>Go to Link 1</p></a>
                    <a href="/"><p>Go to Link 1</p></a>
                </div> */}


        </section>


    )
}

export default Du